import { Modal } from 'lib/components';
import { useOnClickOutside } from 'lib/utils';
import { capitalize } from 'lodash';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-covideo-common';
import { IoMdClose } from 'react-icons/io';
import styled, { useTheme } from 'styled-components/macro';
import { useCDK } from 'lib/hooks/useCdk';

const Header = styled.div`
  display: flex;
`;

const HeaderTitle = styled.div`
  font-weight: 700;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.black[100]};
`;

const CloseButtonWrap = styled.div`
  margin-left: auto;
  color: ${({ theme }) => theme.colors.white[100]};
  height: 24px;
  width: 24px;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  margin-bottom: 24px;
  font-size: 16px;
  min-width: 500px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

type DeactivateModalProps = {
  handleModalClose: () => void;
  type: string;
  onCancel: () => void;
  onSubmit: () => void;
};

const DeactivateReportModal = ({
  handleModalClose,
  type,
  onCancel,
  onSubmit,
}: DeactivateModalProps) => {
  const { t } = useTranslation();
  const themes = useTheme();
  const { destructiveToText } = useCDK();
  const { ref } = useOnClickOutside(handleModalClose);

  const escPress = (key: string) => {
    if (key === 'Escape') {
      handleModalClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keyup', e => escPress(e.key));

    return () =>
      document.removeEventListener('keyup', e => escPress(e.key), true);
  }, []);

  return (
    <Modal style={{ position: 'fixed' }}>
      <div ref={ref} style={{ padding: '32px' }}>
        <Header>
          <HeaderTitle>
            {t('Deactivate {{type}} Report?', { type: capitalize(t(type)) })}
          </HeaderTitle>
          <CloseButtonWrap title={t('Close')}>
            <IoMdClose
              size={24}
              onClick={handleModalClose}
              color={themes.colors.neutral[60]}
            />
          </CloseButtonWrap>
        </Header>
        <Content>{t("Report's data will be reset to the defaults.")}</Content>
        <ButtonContainer>
          <Button
            variant='secondary'
            text={t('No, Keep Active')}
            onClick={onCancel}
          />
          <Button
            variant={destructiveToText}
            text={t('Yes, Deactivate')}
            onClick={onSubmit}
          />
        </ButtonContainer>
      </div>
    </Modal>
  );
};

export default DeactivateReportModal;
